// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"LoadingSkeleton_skeleton__vTGBZ","shine":"LoadingSkeleton_shine__T1kjU","dark":"LoadingSkeleton_dark__50T_8"};